export const PUBLIC_HTML_FOLDER = '/assets/sharpenContents/';
export const staticPageFiles: string[] = ['testHTML.html'];
export const staticPageUrls: {[key: string]: string} = {
  'depression': 'https://www.sharpenminds.com/nview-depression',
  'worry': 'https://www.sharpenminds.com/nview-worry',
  'suicide-prevention': 'https://www.sharpenminds.com/nview-suicideprevention',
  'eating-disorders': 'https://www.sharpenminds.com/nview-eatingdisorders',
};
